import 'core-js/features/promise';
import 'core-js/features/object';
import 'core-js/features/string';
import 'core-js/features/array';
import 'core-js/features/typed-array';

import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { MemoryRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import config from 'config';

import logger, { setLevel, setEnable } from 'common/support/Log';

import App from './App';
import store from './store';

import './index.css';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import './utilities.css';

const render = (Component: React.ComponentType) => {
  ReactDOM.render(
    <Provider store={store}>
      <Router>
        <Component />
      </Router>
    </Provider>,
    document.getElementById('root'),
  );
};

setLevel(config.log.minLevel);
setEnable(config.log.enabled);
logger.addListener((msg, type) => {
  store.dispatch({
    type: 'LOG',
    payload: {
      message: msg,
    },
    metadata: {
      logType: type,
    },
  });
});

render(App);

Modal.setAppElement('#root');


